import styled from 'styled-components';
import { Checkbox as CheckboxAtom } from 'components/atoms/checkbox';
import { CustomLayoutDrawerContent } from 'components/atoms/drawer';

export const Footer = styled.div`
  display: flex;
  gap: var(--spacing-05);
  justify-content: flex-end;
`;

export const DrawerContent = styled(CustomLayoutDrawerContent)`
  ${CustomLayoutDrawerContent.Content} {
    padding: var(--spacing-06);
  }
`;

export const FormWrapper = styled.div`
  margin-top: var(--spacing-06);
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const Checkbox = styled(CheckboxAtom)`
  display: inline-flex;
  align-items: center;
`;
export const CentreAlignWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;
